/* src/app/order/components/company-general-info/company-scope/company-scope.style.scss */
.company-scope {
  display: flex;
  flex-direction: column;
}
.company-scope .iaf-scopes-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.company-scope .iaf-scopes-wrapper .iaf-scopes {
  flex-basis: 60%;
  margin-right: 5px;
  margin-bottom: 10px;
}
.company-scope .iaf-scopes-wrapper .iaf-scopes .scope-checkbox-item {
  white-space: initial !important;
}
.company-scope .iaf-scopes-wrapper .iaf-scopes .iaf-scopes-label-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.company-scope .iaf-scopes-wrapper .iso27-scope {
  flex-basis: 60%;
  margin-bottom: 10px;
}
.company-scope .iaf-scopes-wrapper .iso27-scope .read-only-scope {
  font-size: 0.938rem;
  font-weight: bold;
  margin-top: 15px;
}
.company-scope .iaf-scopes-wrapper .employees-within-scope {
  display: flex;
  flex-direction: column;
}
.company-scope .iaf-scopes-wrapper .employees-within-scope-27x01 {
  display: flex;
  flex-direction: column;
  margin-top: 4px;
}
.company-scope .scope-questions {
  align-items: baseline;
  flex-wrap: nowrap;
}
.company-scope .scope-questions .scope-question {
  margin-top: 10px;
}
.company-scope .scope-questions .scope-question div:first-child {
  padding-right: 0;
}
.company-scope .scope-questions .scope-question div:last-child {
  padding-left: 0;
}
.company-scope .scope-questions .scope-question .scope-question-text {
  font-size: 15px;
  line-height: 1.47;
  color: #585858 !important;
}
.company-scope .scope-questions .scope-question .form-input:first-child {
  width: unset !important;
  min-width: 140px;
  margin-right: 30px;
  margin-bottom: 0;
}
.company-scope .scope-questions .scope-question .form-input:not(:first-child) {
  margin-left: 0 !important;
}
nb-card.scopes-explanation-card {
  margin-bottom: 0 !important;
  border: none !important;
}
nb-card.scopes-explanation-card .explanation-body {
  padding: 10px 12px !important;
  border-radius: 4px;
  border: solid 1px #0044b1;
  background-color: #ffffff;
  display: flex;
}
nb-card.scopes-explanation-card .explanation-body .description {
  font-size: 15px;
  font-family: Arial, sans-serif;
  line-height: 1.47;
  color: #585858;
  max-width: 420px;
}
nb-card.scopes-explanation-card .explanation-body .close-icon {
  flex-basis: 10%;
  flex-shrink: 0;
  cursor: pointer;
  color: #0044b1 !important;
}
nb-card.scopes-explanation-card .header {
  background-color: #0044b1;
}
nb-card.scopes-explanation-card .header nb-icon {
  float: right;
  color: white;
}
nb-radio {
  display: inline-block !important;
}
@media screen and (max-width: 767px) {
  .company-scope .iaf-scopes-wrapper {
    flex-wrap: nowrap;
    flex-direction: column;
  }
  .company-scope .iaf-scopes-wrapper .iaf-scopes {
    margin-right: 0;
  }
  .scope-questions {
    flex-direction: column-reverse;
  }
}
/*# sourceMappingURL=company-scope.style.css.map */
